if (!customElements.get('hero-text-slider')) {
  customElements.define(
    'hero-text-slider',
    class HeroTextSlider extends HTMLElement {
      connectedCallback() {
        const rotator = this.querySelector('rotating-word');
        this.photosContainer = this.querySelector('.hero-text__photos');
        if (!rotator || !this.photosContainer) return;

        this.photos = Array.from(this.photosContainer.querySelectorAll('.hero-text__photo'));
        if (this.photos.length === 0) return;

        this.photosContainer.classList.add('hero-text__photos--slider');

        this.isVisible = false;
        this.activeIndex = 0;

        this.onRotatingWordChange = (event) => this.show(event.detail.index);
        this.addEventListener('rotating-word:change', this.onRotatingWordChange);

        // Videos render with no `autoplay` (see hero-text.liquid) — this
        // observer is what actually starts one playing, only once its slide
        // is both active and scrolled into view, so hidden slides never
        // decode video in the background and a hero further down a `page`
        // template doesn't play before the visitor scrolls to it.
        this.observer = new IntersectionObserver((entries) => {
          this.isVisible = entries[0].isIntersecting;
          this.syncActiveVideo();
        });
        this.observer.observe(this);

        // rotating-word renders earlier in this same wrapper and may have
        // already picked its first word before this element upgrades, so
        // read the current state directly instead of waiting for the next
        // event.
        const words = Array.from(this.querySelectorAll('.hero-text__rotator-word'));
        const activeIndex = words.findIndex((word) => word.classList.contains('is-active'));
        this.show(activeIndex > -1 ? activeIndex : 0);
      }

      show(index) {
        this.activeIndex = index % this.photos.length;
        this.photos.forEach((photo, i) => photo.classList.toggle('hero-text__photo--active', i === this.activeIndex));
        this.syncActiveVideo();
      }

      syncActiveVideo() {
        this.photos.forEach((photo, i) => {
          const video = photo.querySelector('video');
          if (!video) return;
          if (i === this.activeIndex && this.isVisible) {
            if (video.paused) video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      disconnectedCallback() {
        if (this.onRotatingWordChange) this.removeEventListener('rotating-word:change', this.onRotatingWordChange);
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
